import "./AddVipMembers.css";
import { Button, Modal } from "react-bootstrap";
import { showNotificationToast, toastify } from "../../../../helpers/toast/toastify";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cross from "../../../../assets/images/cross.svg";
import FloatingDropdownWithArrow from "../../CommonComponents/FloatingDropdownWithArrow/FloatingDropdownWithArrow.jsx";
import FloatingTextFiled from "../../CommonComponents/FloatingTextFiled/FloatingTextFiled";
import InfoPopup from "../../CommonComponents/InfoPopup/InfoPopup";
import memberAdded from "../../../../assets/images/memberAdded.png";
import useApi from "../../../../helpers/apiHelper/requestHelper.js";
import vipBellPng from "../../../../assets/images/vipBellPng.png";
import Viploader from "../../../../assets/images/Viploader.gif";
import BubbleSvgButton from "../../CommonComponents/BubbleSvgButton/BubbleSvgButton";
import CustomSwitch from "../../CommonComponents/CustomSwitch/CustomSwitch.jsx";
import dayjs from "dayjs";
import { setRefetchSpecificUser } from "../../../../redux/multicommunity/multicommunity.js";
import ExactDateSelector from "../../CommonComponents/ExactDateSelector/ExactDateSelector.jsx";

const AddVipMembers = ({ setIsNewVipAdded }) => {
  const [codeValidity, setCodeValidity] = useState("");
  const [email, setEmail] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [vipSubscription, setVipSubscription] = useState(true);
  const [isAddButtonClicked, setIsAddButtonClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isVipAllowed, setIsVipAllowed] = useState(false);
  const [isVipDisabled, setIsVipDisabled] = useState(false);
  const [showSuccessfullPopUp, setShowSuccessfullPopUp] = useState(false);
  const [warn, setWarn] = useState(false);
  const [isChangeHeight, setisChangeHeight] = useState(false);
  const [formErrors, setFormErrors] = useState({
    email: false,
    codeValidity: false,
  });
  const dispatch = useDispatch();
  const api = useApi();
  const user = useSelector((value) => value?.user?.user);
  const inputRowRef = useRef(null);

  useEffect(() => {
    if (isChangeHeight && inputRowRef.current) {
      setTimeout(() => {
        inputRowRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
    }
  }, [isChangeHeight]);

  useEffect(() => {
    const allSubscriptions = user?.leaderCommunity?.subscription || [];

    const hasVipSubscription = allSubscriptions.filter((sub) =>
      sub.name.endsWith("_Vip")
    )[0];

    setIsVipAllowed(hasVipSubscription?.isAllowed);

    if (!hasVipSubscription) {
      setIsVipDisabled(true);
      setVipSubscription(false);
    }
  }, [user]);

  const toggleVipAccess = async (isAllowed) => {
    const response = await api("post", "vipMember/changeVipAllowedStatus", {
      isAllowed,
    });

    if (response.status) {
      dispatch(setRefetchSpecificUser(true));
      setIsVipAllowed(isAllowed);
      showNotificationToast(response?.message);
    }
  };

  const submitVipMemberRequest = async () => {
    setIsLoading(true);
    setWarn(false);
    setShowSuccessfullPopUp(false);

    if (vipSubscription && !isVipAllowed) {
      setIsAddButtonClicked(true);
      setIsLoading(false);

      return setWarn(true);
    }

    if (!email) {
      setIsLoading(false);
      setFormErrors((prev) => ({
        ...prev,
        email: true,
      }));
      return toastify("Member email missing");
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setIsLoading(false);
      setFormErrors((prev) => ({
        ...prev,
        email: true,
      }));
      return toastify("Member email is not valid");
    }

    if (!codeValidity) {
      setIsLoading(false);
      setFormErrors((prev) => ({
        ...prev,
        codeValidity: true,
      }));
      return toastify("Select access time");
    }

    if (codeValidity === "Specific end date") {
      if (!endDate) {
        setIsLoading(false);
        return toastify("Date missing");
      }
      if (dayjs(endDate).isBefore(dayjs(), "day")) {
        setIsLoading(false);
        return toastify("End date must be in the future");
      }
    }

    const comunityLeaderUrl = `${document.location.origin.replace(
      document.location.pathname,
      ""
    )}/community/${user?.leaderCommunity?.name?.split(" ")?.join("")}`;

    setIsAddButtonClicked(true);
    setIsNewVipAdded(true);

    try {
      const response = await api("post", "vipMember/createCode", {
        codeValidity,
        comunityLeaderUrl,
        email,
        endDate,
      });

      if (response.status) {
        dispatch(setRefetchSpecificUser(true));

        setIsLoading(false);
        setIsNewVipAdded(false);
        setShowSuccessfullPopUp(true);

        if (!vipSubscription) {
          setIsVipDisabled(false);
          setVipSubscription(true);
        }
      }else{
        // console.log(response,"this is response please check and confirm and let me know");
        toastify(response.message);
        setIsAddButtonClicked(false);
        setIsLoading(false);
      }

      setCodeValidity("");
      setEmail("");
      setEndDate(null);
    } catch (error) {
      console.error("🚀 -> submitVipMemberRequest -> error:", error);

      setIsAddButtonClicked(false);
      setIsLoading(false);

      toastify("Failed to add member. Please try again.");
    }
  };

  return (
    <div className={`addVipMemberBox ${!isChangeHeight ? "changeHeight" : ""}`} ref={inputRowRef}>
      <div className="row align-items-center">
        <div className="col-lg-6 col-md-6 col-12">
          <div className="SwithTitle">
            <CustomSwitch
              checked={isChangeHeight}
              onChange={() => {
                setisChangeHeight(!isChangeHeight);
              }}
            />
            <p className="title">
              <span>Add VIP member</span>
              <InfoPopup
                contentItems={[
                  { text: "Add VIP member", type: "heading" },
                  {
                    text: `Use this to onboard existing lifetime or long-term members as VIPs.

VIP members are added at our platform cost of $15/month and won’t be charged your regular subscription price.
If you set an end date, they’ll be offered a paid subscription when the VIP period ends.

You can turn this off anytime once all VIP members are onboarded. Existing VIP access won’t be affected.`,
                    type: "paragraph",
                  },
                ]}
              />
            </p>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <div className="SwithTitle Regular justify-content-lg-end justify-content-md-end">
            <CustomSwitch
              disabled={isVipDisabled}
              checked={isVipAllowed}
              onChange={() => {
                toggleVipAccess(!isVipAllowed);
              }}
            />
            <p className="title">
              <span>Show in onboarding</span>
              <InfoPopup
                contentItems={[
                  { text: "Show in onboarding", type: "heading" },
                  {
                    text: `Control whether new users can see and select the VIP subscription.

Turn this off if you’ve already onboarded all VIP members and don’t want it visible anymore.
Turning it off won’t impact current VIP members or their access.`,
                    type: "paragraph",
                  },
                ]}
              />
            </p>
          </div>
        </div>
      </div>

      {isChangeHeight && (
        <div className="addVipMemberForm">
          <div className="addVipMemberForm__fields">
            <div className="addVipMemberForm__field">
              <FloatingTextFiled
                className={`VipMemberEmail addVipMemberInputWrap${
                  formErrors.email ? " invalid" : ""
                }`}
                forLabel="VipMemberEmail"
                id="VipMemberEmail"
                label="VIP member email"
                onChange={(e) => {
                  setEmail(e.target.value);
                  setFormErrors((prev) => ({
                    ...prev,
                    email: false,
                  }));
                }}
                placeholder="VIP member email"
                type="email"
                value={email}
              />
            </div>

            <div className="addVipMemberForm__field">
              <FloatingDropdownWithArrow
                className={`accessTimeDropDown${
                  formErrors.codeValidity ? " invalid" : ""
                }`}
                id="accessTimeDropDown"
                label="Select access time"
                options={["Lifetime", "Specific end date"]}
                selectedValue={codeValidity}
                setSelectedValue={(value) => {
                  setCodeValidity(value);
                  setFormErrors((prev) => ({
                    ...prev,
                    codeValidity: false,
                  }));
                  if (value !== "Specific end date") {
                    setEndDate(null);
                  }
                }}
                focusedAllowed={false}
              />
            </div>

            <div
              className={`addVipMemberForm__field${
                codeValidity !== "Specific end date" ? " is-disabled" : ""
              }`}
            >
              <ExactDateSelector
                selectedDate={endDate}
                setSelectedDate={setEndDate}
                minDate={dayjs().add(1, "day")}
                label="Select end date"
              />
            </div>
          </div>

          <div
            className="addVipMemberForm__actionRow"
          >
            <BubbleSvgButton
              onClick={submitVipMemberRequest}
              text="Add member"
              type="button"
              variant="black"
              disabled={isLoading}
              containerStyling={{
                justifyContent: "center",
              }}
              mainDivStyle={{
                width: "168px",
                display: "block",
                float: "left",
                marginLeft: 0,
                marginRight: 0,
              }}
            />
          </div>
        </div>
      )}
      {isAddButtonClicked && (
        <div className="addMemberModall">
          <Modal
            backdrop="false"
            id="addMemberModall"
            onHide={() => {
              setIsAddButtonClicked(false);
              setShowSuccessfullPopUp(false);
              setWarn(false);
            }}
            show
          >
            <Modal.Body>
              <div className="modalContent">
                {isLoading && (
                  <div className="LoadingBox">
                    <img alt="" src={Viploader} />
                  </div>
                )}

                {showSuccessfullPopUp && (
                  <>
                    <Button
                      className="closeBtn"
                      onClick={() => {
                        setIsAddButtonClicked(false);
                        setShowSuccessfullPopUp(false);
                        setWarn(false);
                      }}
                    >
                      <img alt="Close Modal" src={cross} />
                    </Button>
                    <div className="regBox success">
                      <div className="img-box">
                        <img alt="Success" src={memberAdded} />
                      </div>
                      <div className="content-box">
                        <p>
                          <span>VIP member has been added!</span>
                          <br />
                          Member has received a sign-up email with a unique VIP
                          code.
                        </p>
                      </div>
                    </div>
                  </>
                )}

                {warn && (
                  <>
                    <Button
                      className="closeBtn"
                      onClick={() => {
                        setIsAddButtonClicked(false);
                        setWarn(false);
                        setShowSuccessfullPopUp(false);
                      }}
                    >
                      <img alt="Close Modal" src={cross} />
                    </Button>
                    <div className="regBox">
                      <div className="img-box">
                        <img alt="Success" src={vipBellPng} />
                      </div>
                      <div className="content-box">
                        <p>
                          <span>VIP member wasn't added!</span>
                          <br />
                          You can't add VIP members before you turn on VIP
                          function.
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default AddVipMembers;
